<template>
	<div
		v-if="visible"
		class="fixed z-10 top-0 left-0 w-full min-h-full p-6 flex flex-col justify-center items-center"
	>
		<div class="fixed z-10 top-0 left-0 w-full min-h-full bg-black opacity-75"></div>
			<div class="relative z-20 shadow-sm rounded-md mb-4 bb-component-background" :class="`w-full max-c-w-${maxW}`">
				<div v-if="title" class="px-4 py-2 pb-0">
					<div class="text-xl font-medium">{{ title }}</div>
				</div>
				<div class="px-4 py-2">
					<slot></slot>
				</div>
				<div v-if="$slots['actions']" class="modal-actions flex flex-row">
					<slot name="actions"></slot>
				</div>
			</div>
	</div>
</template>

<script>
export default {
    name: "Modal",
    props: ["title", "maxW"],
    data() {
        return {
            visible: false
        };
    },
    methods: {
        open() {
            this.visible = true;
            window.document.body.parentNode.style.overflow = 'hidden';
        },
        close() {
            this.visible = false;
            window.document.body.parentNode.style.overflow = '';
        }
    }
};
</script>

<style scoped>
.modal-actions {
	@apply 	text-blue-500;
}
.modal-actions > * {
	@apply w-full font-semibold px-4 py-2 border-t border-r text-center cursor-pointer select-none;
}
.modal-actions > *:last-of-type {
	@apply border-r-0;
}
</style>
<style>
.max-c-w-xs { @apply max-w-xs; }
.max-c-w-sm { @apply max-w-sm; }
.max-c-w-md { @apply max-w-md; }
.max-c-w-lg { @apply max-w-lg; }
.max-c-w-xl { @apply max-w-xl; }
</style>